   export const ValidationStateUI_Login = {
    controls: {
      username: {
        value: "",
        valueType: "Username",
        type: "username",
        placeholder: "Username",
        validation: {
          required: true
        },
        valid: false,
        touched: false,
      },
      password: {
        value: "",
        valueType: "Password",
        type: "password",
        placeholder: "Password",
        validation: {
          required: true,
          minLength: 4,
        },
        valid: false,
        touched: false,
      },
    },
    formIsValid: false,
  };

